<h1 class="title">
  {{ 'static-content-online-booking-process.text.title' | translate }}
</h1>

<div>
  {{ 'static-content-online-booking-process.text.description' | translate }}
</div>

<lib-spacer [height]="40"></lib-spacer>

<div class="step-container">
  <ng-container
    [ngTemplateOutlet]="stepTemplate"
    [ngTemplateOutletContext]="{
      icon: 'storefront',
      title: 'static-content-online-booking-process.text.step-find-salon-title',
      description:
        'static-content-online-booking-process.text.step-find-salon-description'
    }"
  ></ng-container>
  <ng-container
    [ngTemplateOutlet]="stepTemplate"
    [ngTemplateOutletContext]="{
      icon: 'design_services',
      title:
        'static-content-online-booking-process.text.step-select-service-title',
      description:
        'static-content-online-booking-process.text.step-select-service-description'
    }"
  ></ng-container>
  <ng-container
    [ngTemplateOutlet]="stepTemplate"
    [ngTemplateOutletContext]="{
      icon: 'event',
      title:
        'static-content-online-booking-process.text.step-select-date-title',
      description:
        'static-content-online-booking-process.text.step-select-date-description'
    }"
  ></ng-container>
  <ng-container
    [ngTemplateOutlet]="stepTemplate"
    [ngTemplateOutletContext]="{
      icon: 'check',
      title: 'static-content-online-booking-process.text.step-confirm-title',
      description:
        'static-content-online-booking-process.text.step-confirm-description'
    }"
  ></ng-container>
</div>

<ng-template
  #stepTemplate
  let-icon="icon"
  let-title="title"
  let-description="description"
>
  <div
    [fxLayout]="
      (breakpointService.isTabletViewObservable | async) ? 'row' : 'column'
    "
  >
    <div
      [fxLayout]="
        (breakpointService.isTabletViewObservable | async) ? 'column' : 'row'
      "
      [fxFlex]="
        (breakpointService.isTabletViewObservable | async) ? '80px' : 'auto'
      "
      fxLayoutAlign="center center"
    >
      <div class="icon-container">
        <div class="linked-line"></div>

        <div class="icon-wrapper">
          <div class="content">
            <mat-icon>{{ icon }}</mat-icon>
          </div>
        </div>
      </div>
    </div>

    <div
      [fxLayout]="
        (breakpointService.isTabletViewObservable | async) ? 'column' : 'row'
      "
      fxFlex="auto"
      fxLayoutAlign="center start"
    >
      <div class="content-container">
        <div class="step-title">
          {{ title | translate }}
        </div>

        <lib-spacer [height]="5"></lib-spacer>

        <div>
          {{ description | translate }}
        </div>
      </div>
    </div>
  </div>
</ng-template>
